/**
 * Migration runtime : ancien statut `no_show` → annulation facturée (`cancelled` + billable côté events, `cancelled_billable` côté sessions client).
 */

export function normalizeLegacyNoShowClients(clients) {
  return (clients || []).map((c) => ({
    ...c,
    sessions: (c.sessions || []).map((s) => {
      if (s.status !== "no_show") return s;
      return { ...s, status: "cancelled_billable" };
    }),
  }));
}

export function normalizeLegacyNoShowEvents(events) {
  return (events || []).map((e) => {
    if (e.status !== "no_show") return e;
    return { ...e, status: "cancelled", billable: e.billable !== false };
  });
}
